import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const KoveTimeline = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  if (module.hideSection === "no") {
    return (
      <section className="bg-green">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`fullbx-slider py-90 lgscreen:py-30 lgscreen:pb-0${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="anim"
          >
            <div className="w-full max-w-[940px] px-20 mx-auto text-center">
              {module?.heading && (
                <div className="title-white">
                  <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                </div>
              )}
              {module?.description && (
                <motion.div variants={animFade} className="content white">
                  {parse(module.description)}
                </motion.div>
              )}
            </div>
            {module?.timeline && (
              <motion.div
                variants={animFade}
                className="relative mt-40 lgscreen:pb-30"
              >
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  slidesPerView={"1.9"}
                  centeredSlides={true}
                  speed={1000}
                  pagination={{
                    clickable: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    641: {
                      slidesPerView: 1.5,
                    },
                    1024: {
                      slidesPerView: 1.7,
                    },
                  }}
                  modules={[Autoplay, Navigation]}
                >
                  {module.timeline.map((item, index) => (
                    <SwiperSlide key={index}>
                      {item?.image && (
                        <div className="img relative">
                          <ImageOpt
                            imgData={item.image.mediaItemUrl}
                            width={1200}
                            height={600}
                            imgAlt={item.image.altText}
                            imgLoad="lazy"
                          />
                        </div>
                      )}
                      <div className="bg-stone py-15 pl-35 pr-40 laptop:pr-35 xlscreen:pr-40 lgscreen:px-20 lg:min-h-[120px] lgscreen:min-h-[134px] mdscreen:min-h-[178px] flex items-center">
                        <div className="flex xlscreen:flex-wrap xlscreen:flex-col justify-between gap-x-4 items-center">
                          {item?.heading && (
                            <span className="uppercase text-[20px] tracking-05em w-[40%] laptop:w-50-per xlscreen:w-full">
                              {item.heading}
                            </span>
                          )}
                          {item?.description && (
                            <div className="content w-[60%] laptop:w-50-per xlscreen:w-full">
                              {parse(item.description)}
                            </div>
                          )}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="swiper-arrow arrow-big flex gap-x-5">
                  <button
                    className="absolute left-55 lgscreen:left-20 top-[calc(50%_-_40px)] translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                    onClick={() => handlePrevClick(".fullbx-slider .swiper")}
                  >
                    <img
                      src="../images/slider-arrow.svg"
                      width={42}
                      height={42}
                      loading="lazy"
                      alt="Arrow"
                    />
                  </button>
                  <button
                    className="absolute right-55 lgscreen:right-20 top-[calc(50%_-_40px)] translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                    onClick={() => handleNextClick(".fullbx-slider .swiper")}
                  >
                    <img
                      src="../images/slider-arrow.svg"
                      width={42}
                      height={42}
                      className="scale-x-[-1]"
                      loading="lazy"
                      alt="Arrow"
                    />
                  </button>
                </div>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default KoveTimeline
export const PageKoveTimelineFragment = graphql`
  fragment PageKoveTimelineFragment on WpPage_Pagecontent_PageContent_KoveTimeline {
    extraId
    extraClass
    hideSection
    heading
    description
    timeline {
      heading
      description
      image {
        altText
        mediaItemUrl
      }
    }
  }
`
